import { render, staticRenderFns } from "./IssuesForm.vue?vue&type=template&id=256de7a2"
import script from "./IssuesForm.vue?vue&type=script&lang=js"
export * from "./IssuesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports